import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/projects';

export const getProjectsDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
